import React from 'react';

const ReferralRegistrationFormModal = React.lazy(() => import('../components/FormModal'));
const referralRegistrationModalRegistry = {
    core_referralRegistrationId: ReferralRegistrationFormModal
};
export default referralRegistrationModalRegistry;
